module.exports = __webpack_public_path__ + "d41575c617dcef36f5cb57d4cff17ae2.MP3";